import { ID } from '@omneo/omneo-sdk'
import { session } from '@/components/helpers/session'

/**
 * Builds a fresh SDK client. The constructor is local only, and the token is
 * already cached, so this costs no network round trip.
 */
export const defaultCreateClient = () =>
  new ID({
    tenant: GM_STATE.omneo.tenantId,
    IDToken: session.omneoAuthToken.get(),
    IDTokenExpiry: session.omneoAuthExpiry.get()
  })
